import styled from 'styled-components';
import colours from 'theme/atoms/colours';

export const ContributorList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ContributorContainer = styled.div`
  align-items: center;
  border: 1px solid ${colours.neutral[300]};
  border-radius: 5px;
  display: flex;
  padding: 8px;
  gap: 8px;
  width: fit-content;
`;

export const ContributorIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
  }
`;
